<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent>            
            <el-form-item label="所属代理商：">
                <el-input v-model.trim="searchForm.agentName" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="套餐名称 ：">
                <el-input v-model.trim="searchForm.packageName" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="卡号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="订单号：">
                <el-input v-model.trim="searchForm.orderNo" @keyup.enter.native="getAgentOrderListHandle" clearable></el-input>
            </el-form-item>
           
            <el-form-item label="退款时间：" class="dateRange"> 
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getAgentOrderListHandle" plain icon="el-icon-search">搜索查询</el-button>
                <el-button type="success" @click="exportAgentOrderInfoHandle" plain icon="el-icon-s-ticket">导出Excel</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData"
		border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"
		> 
            <el-table-column prop="orderNo" label="退款订单号" align="center"></el-table-column>
             <el-table-column  align="center"  label="来源订单号" >
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.backOrderNo">
                        <p style="color:#5c7eff"> {{scope.row.backOrderNo}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column prop="agentName" label="所属代理商"  align="center"></el-table-column>
            <el-table-column prop="iccid" label="卡号"  align="center"></el-table-column>
             <el-table-column  align="center"  label="套餐名称" >
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.orderNo">
                        <p style="color:#5c7eff"> {{scope.row.packageName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column prop="priceRmb" label="订单金额(元)"  align="center"></el-table-column>
             <el-table-column  align="center"  label="退款金额" >
                 <template v-slot="scope">
                    <el-tooltip  :content="scope.row.backOrderNo">
                        <p style="color:red"> {{scope.row.commissionRmb}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
           <el-table-column  align="center"  label="支付状态" >
                 <template v-slot="scope">
                    <el-tooltip v-if="scope.row.payState==1" class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:green"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                  <el-tooltip v-else-if="scope.row.payState==3||scope.row.payState==4" class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:red"> {{scope.row.payStateName}}</p>
                    </el-tooltip>
                    <el-tooltip v-else class="item" effect="dark" :content="scope.row.orderNo">
                        <p style="color:teal"> {{scope.row.payStateName}}</p>
                    </el-tooltip> 
                </template>
            </el-table-column>
            <el-table-column prop="createTime" label="退款时间"  align="center"></el-table-column>
        </el-table>

        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500,2000,5000,10000]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 
        
    </div>
</template>
<script>
import {agentBackMoneyList,exportAgentOrderInfo} from '@/api/order.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                agentName: '',
                packageName: '',
                iccid: '',
                orderNo: '',
                backOrderNo: '',
                time: '',
                payState:''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            }
        }
    },
    methods: {
        getAgentOrderListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            agentBackMoneyList(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        showOrderDetail(row){
            this.orderDetailVisible = true;
            this.orderDetailForm = row;
        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getAgentOrderListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getAgentOrderListHandle();
        },
        exportAgentOrderInfoHandle($event){//导出代理商微信订单
             this.searchForm.payState=3;
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            exportAgentOrderInfo(data).then(res =>{
                if(res.data.code == 200){
                    this.$message.success('数据导出中,请稍候去任务中心下载');
                }else{
                    this.$message.error(res.data.msg);
                }
            }).catch(err=>console.error(err));     
        }        
    },
    created(){
        this.getAgentOrderListHandle();
    }
}
</script>
<style lang="less" scoped>

</style>
